export default {"src":"/_next/static/media/crossIcon.fc11813a.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};